import { CloseCircleFilled, InboxOutlined, SearchOutlined } from "@ant-design/icons";
import { ContentCopyOutlined } from "@mui/icons-material";
import { Box } from "@mui/material";
import { GridOverlay } from "@mui/x-data-grid";
import { AutoComplete, Cascader, Select, Spin } from "antd";
import Paragraph from "antd/es/typography/Paragraph";
import Typography from "antd/es/typography/Typography";
import { isEmpty } from "../../utils/helpers";

export const CustomLoaderOverlay = () => (
  <GridOverlay>
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
      }}
    >
      <Spin size="large" />
    </div>
  </GridOverlay>
);

export const CustomNoRowsOverlay = () => (
  <GridOverlay>
    <div
      className="flex flex-col justify-center items-center h-full space-y-2"
    >
      <InboxOutlined className="!text-3xl !text-gray-400" />
      <p className="text-sm font-light text-black/50">No Results Found</p>
    </div>
  </GridOverlay>
);

export const CopyCommand = ({ content }) => {
  const { Text } = Typography;
  return (
    <Box className="!bg-gray-300 rounded-md py-2 px-3 !flex justify-between items-center hover:!bg-white hover:shadow-md command-box">
      <div>{content}</div>
      <div>
        <Text copyable={{
          text: content,
          icon: <ContentCopyOutlined className="!text-black" />,
          tooltips: ["Copy Command", "Copied"],
        }} />
      </div>
    </Box>
  )
}

export const AutoCompleteInput = ({ label = false, inputValue, name, handleOnClear, handleSearch, options, handleOnChange, placeholder = "" }) => {
  return (
    <div>
      {label && <Paragraph className='input-label'>{label}</Paragraph>}
      <AutoComplete
        value={inputValue}
        prefix={<SearchOutlined />}
        placeholder={isEmpty(placeholder) ? `Search ${label}` : placeholder}
        allowClear={{ clearIcon: <CloseCircleFilled /> }}
        onClear={() => handleOnClear(name)}
        onSearch={handleSearch}
        options={options}
        onChange={(value) => handleOnChange(value, name)}
      />
    </div>
  )
}

export const CasderCascaderFilter = ({ label = false, options = [], placeholder = "", name = "", handleOnChange = () => { }, handleOnClear = () => { }, customDisplayRender = false, customFilterRender = false }) => {


  const filterRender = (inputValue, path) =>
    path.some((option) => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);

  const displayRender = (labels) => labels[labels.length - 1];

  return (
    <div>
      {label && <Paragraph className='input-label'>{label}</Paragraph>}
      <Cascader
        options={options}
        placeholder={placeholder}
        expandTrigger="hover"
        displayRender={customDisplayRender ? customDisplayRender : displayRender}
        onChange={(_, data) => handleOnChange(data, name)}
        showSearch={{ filter: customFilterRender ? customFilterRender : filterRender }}
        onClear={() => handleOnClear()}
      />
    </div>
  )
}

export function CustomTabs({ tabStrucure = [], activeTab = "", handleTabChange = () => { } }) {
  return (
    <>
      {tabStrucure.map((item, index) => {
        const icon = item.icon || false;
        return (
          <button key={`tabs-${index}`} onClick={() => handleTabChange(item.key)} className={`flex items-center px-4 py-3 text-sm font-medium whitespace-nowrap border-b-2 ${activeTab === item.key ? "border-blue-500 text-blue-600" : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"}`}>
            {icon && <span className="mr-2">{icon}</span>}
            {item.label}
          </button>
        );
      })}
    </>
  );
}


export const FilterComponents = ({ uiStructure }) => {
  return (
    <div className="grid md:grid-cols-5 gap-3 mb-4">
      {
        uiStructure?.map((item) => {
          if (item?.isAutocomplete) return <AutoCompleteInput placeholder={item?.placeholder} label={item?.labelName} name={item?.inputName} handleOnClear={item?.handleOnClear} inputValue={item?.inputValue} handleSearch={item?.handleSearch} options={item?.results} handleOnChange={item?.handleOnChange} />
          if (item?.isSelect) {
            const { Option } = Select;
            return (<div className="flex flex-col">
              <Paragraph className='input-label'>{item?.labelName}</Paragraph>
              <Select
                classNames={{ popup: { root: 'max-h-[250px] overflow-y-auto' } }}
                showSearch={item?.isSearch || false}
                allowClear
                placeholder={`Select ${item?.labelName}`}
                optionFilterProp={item?.isSearch ? "label" : "children"}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                value={item?.inputValue}
                onChange={(value) => item?.handleOnChange(value, item?.inputName)}
              >
                {
                  item?.options?.map((optionItem, optionIndex) => (<Option key={`${item?.inputName}-${optionIndex}`} value={optionItem?.value} >{optionItem?.name}</Option>))
                }
              </Select>
            </div>)
          }
          if (item?.isFilter) return <CasderCascaderFilter label={item?.labelName} options={item?.options} placeholder={item?.placeholder} name={item?.inputName} handleOnChange={item?.handleOnChange} inputValue={item?.inputValue} customDisplayRender={item?.customDisplayRender || false} customFilterRender={item?.customFilterRender || false} />
          return <></>
        })
      }
    </div>
  )
}